import { equipmentStatusesSlice } from "./equipmentStatusesSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = equipmentStatusesSlice;
export const moduleUrl = "/api/assetmanagement/equipmentstatuses"

// Default actions currying
export const setValidationErrors = actions.setValidationErrors;

export const getEquipmentStatuses = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);

export const getEquipmentStatus = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);

export const saveEquipmentStatus = (user: {}, id: string | null) => defaultActions.saveItem(moduleUrl, actions, user, id);

export const deleteEquipmentStatus = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const clearAll = () => defaultActions.clearAll(actions);
export const clearEquipmentStatus = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);


